import type { ComponentType, MouseEvent } from 'react';

import { StyledBasicSubtitle, StyledIcon, Wrapper } from './SidebarLink.styled';

interface SidebarLink {
  Icon: ComponentType;
  text: string;
  disabled?: boolean;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}

export const SidebarLink = ({ Icon, text, disabled = false, onClick }: SidebarLink) => {
  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    if (!disabled) {
      onClick(e);
    }
  };

  return (
    <Wrapper $isDisabled={disabled} onClick={handleClick}>
      <StyledIcon as={Icon} $isDisabled={disabled} />

      <StyledBasicSubtitle $isDisabled={disabled}>{text}</StyledBasicSubtitle>
    </Wrapper>
  );
};
